import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "loading": _vm.isFetchingAvailableStates,
      "multiple": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.twinAttributesSelector.inputs.attributesSelect.label'),
      "items": _vm.itemsForAttributesSelectInput,
      "item-text": "text",
      "item-value": "value",
      "data-cy": "attribute-selector"
    },
    model: {
      value: _vm.attributes,
      callback: function ($$v) {
        _vm.attributes = $$v;
      },
      expression: "attributes"
    }
  })], 1)], 1), _c('draggable', {
    attrs: {
      "handle": ".handle .fa-grip-vertical"
    },
    on: {
      "start": function ($event) {
        _vm.attributeIsDragged = true;
      },
      "end": function ($event) {
        _vm.attributeIsDragged = false;
      }
    },
    model: {
      value: _vm.attributes,
      callback: function ($$v) {
        _vm.attributes = $$v;
      },
      expression: "attributes"
    }
  }, _vm._l(_vm.attributes, function (attribute, index) {
    return _c(VRow, {
      key: attribute,
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      attrs: {
        "grow": ""
      }
    }, [_c(VTextField, {
      staticClass: "handle",
      attrs: {
        "value": _vm.getProperty(index, 'label'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "label": attribute.startsWith('state.') ? _vm.$t('Dashboards.components.twinAttributesSelector.inputs.attributeLabel.label', {
          key: attribute.replace('state.', '')
        }) : _vm.get(_vm.twinFields, `['${attribute}'].defaultLabel`),
        "placeholder": attribute.startsWith('state.') ? attribute.replace('state.', '') : _vm.get(_vm.twinFields, `['${attribute}'].defaultLabel`),
        "clearable": "",
        "append-icon": _vm.appendIcon !== undefined && (typeof _vm.appendIcon === 'function' ? _vm.appendIcon(index) : _vm.appendIcon),
        "prepend-icon": "fal fa-grip-vertical"
      },
      on: {
        "input": function ($event) {
          return _vm.setProperty(index, 'label', $event);
        },
        "click:append": function ($event) {
          return _vm.$emit('click:append-icon', index);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c(VTextField, {
      attrs: {
        "value": _vm.getProperty(index, 'width'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "label": _vm.$t('Dashboards.components.twinAttributesSelector.inputs.width.label'),
        "placeholder": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.setProperty(index, 'width', $event);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c(VBtn, {
      attrs: {
        "icon": ""
      },
      on: {
        "click": () => _vm.removeAttribute(index)
      }
    }, [_c(VIcon, [_vm._v("fal fa-trash")])], 1)], 1)], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };